module.exports = __webpack_public_path__ + "img/typo_round_1024.dda0406c.png";